import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Card, Col, Modal, Row, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from 'prop-types';
import AssemblerCard from "./assembler/AssemblerCard";
import ControllerFWVersionHistoryCard from "./assembler/ControllerFWVersionHistoryCard";
import {parseDate} from "enqc-utilities/src/utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../utils/Global";

export default class AssemblyHistoryDetailModal extends BaseComponent{

    constructor(props) {
        super(props);
        let {assemblyHistory, show} = this.props
        if(!assemblyHistory){
            assemblyHistory = {}
        }
        this.state = {
            assemblyHistory:assemblyHistory?assemblyHistory:{},
            show:show
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {assemblyHistory,show} = nextProps
            if(!assemblyHistory){
                assemblyHistory = {}
            }
            this.setState({assemblyHistory,show},() => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }
    }


    render() {
        let {assemblyHistory,show} = this.state
        let {user} = assemblyHistory
        if(!user){
            user = {}
        }
        let {serialComponent} = assemblyHistory
        if(!serialComponent){
            serialComponent = {}
        }
        let {components} = serialComponent
        if(!components){
            components = []
        }

        let {rectifierControllerEntry} = assemblyHistory
        if(!rectifierControllerEntry){
            rectifierControllerEntry = {}
        }
        let {rectifierControllerSerialNumbers} = rectifierControllerEntry
        if(!rectifierControllerSerialNumbers){
            rectifierControllerSerialNumbers = []
        }

        return (
            <>
                {super.render()}
                <Modal as={Modal.Dialog} size="xl" centered show={show} onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">{label.AssemblyHistoryDetail} - {label.Updated} @({parseDate(assemblyHistory.updated, DD_MMMM_YYYY_HH_MM_SS)})</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <Row>
                            <Col md={4}>
                                <Row>
                                    <Col>
                                        <AssemblerCard
                                            user={user}
                                            showProcessing={this.props.showProcessing}
                                            closeProcessing={this.props.closeProcessing}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <ControllerFWVersionHistoryCard
                                            headerClassName={"p-2"}
                                            assemblyHistory={assemblyHistory}/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={8}>
                                <Row>
                                    <Col>
                                        <Card size="sm" className="p-0">
                                            <Card.Header className="p-2">
                                                {label.Component}
                                            </Card.Header>
                                            <Card.Body className="p-0">
                                                <Table responsive className="table-sm align-items-center table-flush">
                                                    <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col" className="text-left">{label.Label}</th>
                                                        <th scope="col" className="text-left">{label.Value}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {components.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td scope="row">{index+1}</td>
                                                                <td scope="row" className="text-left">
                                                                    <span className="rounded text-black font-small p-0 fw-bolder text-left">
                                                                        {item.label}
                                                                    </span>
                                                                </td>
                                                                <td className="text-left">
                                                                    {item.value}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                    </tbody>
                                                </Table>

                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <br/>
                                <Row>
                                    <Col>
                                        <Card size="sm" className="p-0">
                                            <Card.Header className="p-2">
                                                {label.RectifierControllerSerialNumber}
                                            </Card.Header>
                                            <Card.Body className="p-0">
                                                <Table responsive className="table-sm align-items-center table-flush">
                                                    <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">{label.Order}</th>
                                                        <th scope="col">{label.Value}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {rectifierControllerSerialNumbers.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td scope="row">{index+1}</td>
                                                                <td scope="row" >
                                                                    <span className="rounded text-black font-small p-0 ps-2 pe-2 fw-bolder">
                                                                        #{item.indexOrder}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    {item.serialCode}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                    </tbody>
                                                </Table>

                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
AssemblyHistoryDetailModal.propTypes = {
    assemblyHistory:PropTypes.object.isRequired,
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired

}
